/*
 * The classic chat window's reply text, one line at a time, as HTML.
 *
 * The server sends plain text with "**bold**" and, since the partner look-up
 * (ClickUp 1248h53bmhy), in-app links written [Acme Ltd](/dashboard/crm/profile/12).
 * Everything else is shown as typed: the text is escaped first, so nothing a
 * reply contains can become markup, and only a link to a page of this system
 * (a path starting with one "/") becomes a link; any other address stays
 * plain words. The window opens these links without reloading the page
 * (see HamsterChatWindow's click handling on data-inapp).
 */
const escapeHtml = (text) => String(text)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

export const IN_APP_LINK = /\[([^\]]+)\]\((\/(?!\/)[^)\s]*)\)/g;

export const isInAppPath = (href) => typeof href === 'string' && href.startsWith('/') && !href.startsWith('//');

export function formatMessageLine(line) {
  const escaped = escapeHtml(line == null ? '' : line);
  return escaped
    .replace(IN_APP_LINK, (_m, text, href) => `<a href="${href}" data-inapp="1">${text}</a>`)
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
}

/* For a click anywhere in the messages: the in-app link that was clicked, or null. */
export function clickedInAppLink(event) {
  const anchor = event?.target?.closest ? event.target.closest('a[data-inapp]') : null;
  if (!anchor) return null;
  const href = anchor.getAttribute('href') || '';
  return isInAppPath(href) ? href : null;
}
